<template>
  <div class="user">
    <transition name="nexum-fade">
    <nexum-nav-bar v-if="!isScrolling"></nexum-nav-bar>
    </transition>
    <div class="main-content">
        <router-view></router-view>
    </div>
    <back-top-button></back-top-button>
    <div class="user-footer">
      <b-container>
        <p>&copy; NEXUM FINANZA 2018 | Condiciones de uso y política de privacidad</p>
      </b-container>
    </div>
  </div>
</template>
<style lang="scss">
  @import "../../theme/nexum-bootstrap";
  @import "../../../node_modules/bootstrap/scss/bootstrap.scss";
  .nexum-fade-enter-active,
  .nexum-fade-leave-active {
    transition: opacity 1.2s ease-in-out;
  }
  .nexum-fade-enter,
  .nexum-fade-leave-to {
    opacity: 0;
  }
  .main-content {
    margin-top: 77px;
    margin-bottom: 100px;
    padding-bottom: 40px;
    background-color: white;
    @include media-breakpoint-down(xl) {
      margin-top: 130px;
    }
    @include media-breakpoint-down(lg) {
      margin-top: 120px;
    }
    @include media-breakpoint-down(sm) {
      margin-top: 50px;
    }
  }
  .user-footer {
    text-align: right;
    position: fixed;
    bottom: 0;
    min-height: 100px;
    z-index:-1;
    @include media-breakpoint-down(md) {
      min-height: 50px;
    }
    @include media-breakpoint-down(sm) {
      min-height: 30px;
    }
    width: 100%;
    background-image: $linear-orange;
    p {
      margin: 40px 0;
      color: white;
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';
  import store from '@/store';
  import taxonomyModule from '@/features/taxonomy/store';
  import documentsModule from '@/features/documents/store';
  import backTop from '@/features/back-top-button/BackTopButton';
  import MediaQueryMixin from '@/mixin/mediaquery.mixin';
  import AppraiserModule from '@/features/appraiser/store';
  import AjdModule from '@/features/ajd/store';
  import proposalModule from '@/features/propuesta-no-vinculante/store';
  import reportModule from '@/features/reports/store';
  import NotaryModule from '@/features/notary/store';
  import FormalizacionModule from '@/features/formalizacion/store';
  import CancelacionModule from '@/features/cancelacion/store';
  import CollaboratorFeatureModule from '@/features/colaborador/store';
  import CollaboratorMenuModule from '@/features/menu-colaboradores/store';
  import AnalisisModule from '@/features/analisis/store';
  import RiesgosModule from '@/features/sancion-riesgos/store';
  // MODELS
  import { CollaboratorModule } from '@/models/colaborador';
  import { ContactoModule } from '@/models/contacto';
  import { ReputationModule } from '@/models/reputation';
  import { OperationModule } from '../../models/operation';
  import { ClientModule } from '../../models/client';
  import { DatesAssignementsModule } from '../../models/datesAssigments';
  import { CesionModule } from '../../models/cesion';
  import { InversorModule } from '../../models/inversor';
  import { TaxonomyLetraModule } from '../../models/taxonomyLetra';
  import { InstanciaLetraModule } from '../../models/instanciaLetra';
  import { InstanciaLetraCesionModule } from '../../models/instanciaLetraCesion';
  import { EmployeeModule } from '../../models/employee';
  import NavBar from './UserNavBar.component';
  import { ExpensesModule } from '../../models/expenses';
  import { ProvisionModule } from '../../models/provision';
  import { BusinessCardModule } from '../../models/businessCard';
  import { ReportModule } from '../../models/report';
  import { PreReportModule } from '../../models/prereport';
  import { NotarioModule } from '../../models/notary';
  import { OwnerModule } from '../../models/owner';

  if (!module.hot) {
    store.registerModule('notary', NotaryModule);
    store.registerModule('formalizacion', FormalizacionModule);
    store.registerModule('cancelacion', CancelacionModule);
    store.registerModule('collaborator', CollaboratorFeatureModule);
    store.registerModule('analisis', AnalisisModule);
    store.registerModule('ajd', AjdModule);
    store.registerModule('appraiser', AppraiserModule);
    store.registerModule('taxonomy', taxonomyModule);
    store.registerModule('documents', documentsModule);
    store.registerModule('propuestano', proposalModule);
    store.registerModule('report', reportModule);
    store.registerModule('menu_colaborador', CollaboratorMenuModule);
    store.registerModule('riesgos', RiesgosModule);
    // MODELS
    store.registerModule('operation_model', OperationModule);
    store.registerModule('client_model', ClientModule);
    store.registerModule('datesAssignements_model', DatesAssignementsModule);
    store.registerModule('cesion_model', CesionModule);
    store.registerModule('letra_tax_model', TaxonomyLetraModule);
    store.registerModule('instanciaLetra_model', InstanciaLetraModule);
    store.registerModule('inversor_model', InversorModule);
    store.registerModule('collaborator_model', CollaboratorModule);
    store.registerModule('employee_model', EmployeeModule);
    store.registerModule('instanciaLetraCesion_model', InstanciaLetraCesionModule);
    store.registerModule('contact_model', ContactoModule);
    store.registerModule('reputation_model', ReputationModule);
    store.registerModule('expenses_model', ExpensesModule);
    store.registerModule('provision_model', ProvisionModule);
    store.registerModule('businessCard_model', BusinessCardModule);
    store.registerModule('report_model', ReportModule);
    store.registerModule('prereport_model', PreReportModule);
    store.registerModule('notario_model', NotarioModule);
    store.registerModule('owner_model', OwnerModule);
  }

  const rootStore = store;

  export default {
    mixins: [MediaQueryMixin],
    components: {
      'nexum-nav-bar': NavBar,
      'back-top-button': backTop,
    },
    data() {
      return {
        initialScroll: 0,
        isScrolling: false,
      };
    },
    computed: {
      ...mapGetters({
        user: 'user',
        layout: 'layout',
      }),
    },
    watch: {
      $route() {
        this.isScrolling = false;
        store.dispatch('changeScrollYAction', 0);
        this.initialScroll = 0;
      },
    },
    beforeRouteEnter(to, from, next) {
      rootStore.dispatch('operation_model/fetchAction', {}, { root: true })
        .then(() => rootStore.dispatch('letra_tax_model/fetchAction', {}), { root: true })
        .then(() => rootStore.dispatch('datesAssignements_model/fetchAction', {}), { root: true })
        .then(() => next((vm) => {
          const promises = [];
          promises.push(vm.$store.dispatch('taxonomy_department/fetchAction', {}), { root: true });
          promises.push(vm.$store.dispatch('taxonomy/updateTaxonomiesAction', {}), { root: true });
          promises.push(vm.$store.dispatch('documents/loadDocumentTypesAction', {}), { root: true });
          vm.$store.commit('PERFORMING_LOGIN', false);
        }));
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
      this.$store.dispatch('client_model/fetchAction', {});
      this.$store.dispatch('letra_tax_model/fetchAction', {});
      this.$store.dispatch('taxonomy_department/fetchAction', {});
      this.$store.dispatch('employee_model/fetchAction', {});
    },
    methods: {
      handleScroll() {
        if (this.layout.scrollY === 0) {
          this.isScrolling = false;
        }
        if (this.layout.scrollY < 200) {
          return;
        }
        if (this.layout.scrollY > this.initialScroll) {
          this.isScrolling = true;
        }
        if (this.layout.scrollY < this.initialScroll) {
          this.isScrolling = false;
        }
        this.initialScroll = this.layout.scrollY;
      },

    },
  };
</script>



// WEBPACK FOOTER //
// src/features/user/User.page.vue